// extracted by mini-css-extract-plugin
module.exports = {"topic":"topic_topic__3wczx","titleContainer":"topic_titleContainer__3BzJT"};